import { render, staticRenderFns } from "./VerDatosAfiliatorios.vue?vue&type=template&id=0da201be"
import script from "./VerDatosAfiliatorios.vue?vue&type=script&lang=js"
export * from "./VerDatosAfiliatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports